import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { showToast } from '../Utils/toast';

const PlaylistFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  mode = 'create',
  initialValues = { name: '' },
  isLoading = false
}) => {
  const [name, setName] = useState(initialValues.name || '');

  useEffect(() => {
    if (isOpen) {
      setName(initialValues.name || '');
    }
  }, [isOpen, initialValues]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    const trimmedName = name.trim();
    if (!trimmedName) {
      showToast.error('Playlist name is required');
      return;
    }
    if (trimmedName.length > 100) {
      showToast.error('Playlist name too long (max 100 characters)');
      return;
    }

    onSubmit({ name: trimmedName });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={mode === 'create' ? 'Create Playlist' : 'Edit Playlist'}
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Playlist Name */}
        <div>
          <label
            htmlFor="playlist-name"
            className="block text-sm font-medium text-text mb-2"
          >
            Playlist Name
          </label>
          <input
            id="playlist-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="My Awesome Playlist"
            autoFocus
            disabled={isLoading}
            className="
              w-full px-3 py-2 bg-transparent border border-neutral-700 focus:border-accent rounded-lg text-text placeholder:opacity-50 transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed
            "
            maxLength={100}
          />
          <p className="text-xs text-text opacity-70 mt-2">
            You can share this playlist after creating it using the Share option
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 mt-6 pt-4 border-t border-secondary">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="
              flex-1 px-4 py-2 text-text hover:bg-secondary rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="
              flex-1 px-4 py-2 bg-accent text-white rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed font-medium
            "
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                {mode === 'create' ? 'Creating...' : 'Saving...'}
              </span>
            ) : (
              mode === 'create' ? 'Create Playlist' : 'Save Changes'
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default PlaylistFormModal;
